import axios from "axios";
import toast from "react-hot-toast";

import { Button } from "@/components/ui/button";

const API_URL = import.meta.env.VITE_API_URL as string;

interface BookDetailProps {
  bookData: Record<string, string | string[]>;
}

const BookDetail: React.FC<BookDetailProps> = ({ bookData }) => {
  const handleConfirm = async () => {
    const bibliography = bookData["شماره کتابشناسی ملی"];
    if (!bibliography || typeof bibliography !== "string") {
      toast.error("شماره کتابشناسی ملی معتبر نیست");
      return;
    }

    try {
      toast.loading("در حال ذخیره‌سازی اطلاعات کتاب...", {
        id: "confirm-toast"
      });

      await axios.post(
        `${API_URL}/book/BookOwnershipConfirmation/${bibliography}`
      );

      toast.success("کتاب با موفقیت ذخیره شد", { id: "confirm-toast" });
    } catch {
      toast.error("خطا در ذخیره‌سازی کتاب", { id: "confirm-toast" });
    }
  };

  return (
    <div
      className="relative mx-auto mt-10 rounded-lg bg-white p-4 px-8 text-right font-sans text-black shadow-md"
      dir="rtl"
    >
      <div className="mt-6 space-y-3 pb-20">
        {Object.entries(bookData).map(
          ([label, value], index) =>
            value && (
              <div key={index} className="flex gap-4">
                <span className="min-w-[160px] align-top text-sm font-semibold text-slate-500">
                  {label}:
                </span>
                <span className="text-[15px] font-bold leading-7">{value}</span>
              </div>
            )
        )}
      </div>

      <div className="fixed bottom-0 left-0 z-10 flex h-12 w-full items-start bg-white">
        <div className="flex-1">
          <div className="h-[20px] border-b border-slate-300 bg-[#F8F8FB]"></div>
        </div>
        <div className="flex h-[20px] w-64 justify-center overflow-visible rounded-tr-lg border-r border-t border-slate-300">
          <Button
            onClick={handleConfirm}
            className="mt-3 h-8 rounded-md bg-primary px-6 text-sm text-white transition-colors hover:bg-primary/90"
          >
            تایید مالکیت کتاب
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BookDetail;
